import NrwRepository from "./NrwRepository";

export default class NrwService {
  private readonly nrwRepository: NrwRepository = new NrwRepository();

  async getMROReport(locationId: any): Promise<any> {
    return this.nrwRepository.getNrwReport(locationId);
  }

  async getNRWDates(
    locationId: string | number,
    startDate: string,
    endDate: string
  ): Promise<any> {
    console.log(
      `Launching getNRWDates with locationId: ${locationId}, startDate: ${startDate}, endDate: ${endDate}`
    );
    return this.nrwRepository.getNRWDates(
      locationId,
      startDate,
      endDate
    );
  }
}
